import { Dimensions, Platform, StatusBar, StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme/fontFamily'

const Height = Dimensions.get('screen').height / 1.4

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(5, 16, 45)',
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  },
  maincontainer: {
    flex: 1,
    backgroundColor: 'rgb(5, 16, 45)'
  },
  screenHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 14
  },
  buttonText: {
    textAlign: 'center',
    fontWeight: '800',
    fontSize: moderateScale(16),
    fontFamily: fontFamily.sfProDisplayHeavy
  },
  tournamentTitle: {
    fontSize: moderateScale(14),
    fontFamily: fontFamily.sfProDisplayHeavy,
    color: 'white'
  },
  seatLeftContainer: {
    height: moderateScale(18),
    marginTop: 5,
    paddingVertical: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  seatLeft: {
    fontSize: moderateScale(13),
    fontFamily: fontFamily.sfProDisplayRegular,
    color: 'white'
  },
  gameCardContainer: {
    flex: 1,
    borderRadius: 8,
    margin: 2.5
  },
  gameCardImageContainer: {
    padding: 2,
    height: 135,
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },
  tournamentDetailsContainer: {
    backgroundColor: '#232335',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 5
  },
  gradientButton: {
    flex: 1,
    borderRadius: 8,
    justifyContent: 'center',
    height: 36
  },
  emptyContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: Height
  },
  emptyText: {
    fontSize: moderateScale(14),
    fontFamily: fontFamily.sfProDisplayHeavy
  },
  difficultyView: {
    height: moderateScale(18),
    marginTop: 5,
    paddingVertical: 1,
    justifyContent: 'flex-start'
  },
  difficulty: {
    fontSize: moderateScale(15),
    fontFamily: fontFamily.sfProDisplayHeavy,
    color: 'white'
  },
  ppScheduleButton: {
    justifyContent: 'center',
    alignSelf: 'center'
  },
  viewPPScheduleButton: {
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 15,
    height: 36
  },
  ppScheduleText: {
    textAlign: 'center',
    fontWeight: '700',
    fontSize: moderateScale(16),
    fontFamily: fontFamily.sfProDisplayBold
  },
  calIcon: {
    height: 22,
    width: 22,
    marginLeft: 8
  },
  plusIcon: { position: 'absolute', right: 2 },
  headerContainerStyle: {
    borderBottomWidth: 0.2,
    borderBottomColor: '#fff',
    paddingHorizontal: 18
  },
  leftIconStyle: {
    tintColor: '#fff'
  }
})

export default styles
